import type { GetRooftopFeaturesResponseDTO } from 'declarations/dto/features';

import { get } from './api';

export const getRooftopFeaturesApi = async (
  roofTopId: string
): Promise<GetRooftopFeaturesResponseDTO> => {
  const response = await get<GetRooftopFeaturesResponseDTO>(`/rooftop-features/${roofTopId}`);

  return response.data;
};
